import { api } from '@/features/auth';

import { CompanyRequest, CompanyResponse, UpdateCompanyRequest } from './types';

export const companyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompany: builder.query<CompanyResponse['data'], CompanyRequest>({
      query: ({ id }: CompanyRequest) => ({
        url: `items/companies/${id}`,
        method: 'GET',
        params: {
          fields: [
            'id',
            'name',
            'description',
            'website',
            'logo',
            'short_description',
            'hq_country',
            'linkedin',
            'verified',
            'registered_name',
            'vat_number',
            'billing_email',
            'billing_address',
            'billing_postal_code',
            'billing_city',
            'billing_country',
            'billing_aditional_info',
            'activity_interests',
            'technology_interests',
            'other_technology',
            'capacity_interests',
            'countries_interests',
            'location_interests',
            'bess_size',
            'development_status_interests',
            'solar_size',
            'solar_development_status',

            //Suscriptions fields:
            'suscriptions.id',
            'suscriptions.end_at',
            'suscriptions.renew_at',
            'suscriptions.renewal_cycle',
            'suscriptions.start_at',

            //UserSchema:
            'users.id',
            'users.status',
            'users.first_name',
            'users.last_name',
            'users.email',
            'users.language',
            'users.avatar',
            'users.title',
            'users.description',
            'users.phone_number',
            'users.role.id',
            'users.role.name',
          ],
        },
      }),
      transformResponse: ({ data }: CompanyResponse) => data,
      providesTags: (_result, _error, args) => [{ type: 'Companies', id: args.id }],
    }),
    updateCompany: builder.mutation<CompanyResponse['data'], UpdateCompanyRequest>({
      query: ({ id, data }: UpdateCompanyRequest) => ({
        url: `items/companies/${id}`,
        params: {
          fields: [
            'id',
            'name',
            'description',
            'website',
            'logo',
            'short_description',
            'hq_country',
            'linkedin',
            'verified',
            'registered_name',
            'vat_number',
            'billing_email',
            'billing_address',
            'billing_postal_code',
            'billing_city',
            'billing_country',
            'billing_aditional_info',
            'activity_interests',
            'technology_interests',
            'other_technology',
            'capacity_interests',
            'countries_interests',
            'location_interests',
            'bess_size',
            'development_status_interests',
            'solar_size',
            'solar_development_status',
          ],
        },
        method: 'PATCH',
        body: data,
      }),
      transformResponse: ({ data }: CompanyResponse) => data,
      invalidatesTags: (_result, _error, args) => [
        { type: 'Companies', id: args.id },
        { type: 'Users', id: 'me' },
      ],
    }),
  }),
});

export const { useGetCompanyQuery, useUpdateCompanyMutation } = companyApi;
